const origemEnum = {
  GRE: 1,
  SEE: 2,
  ESCOLA: 3,
  values: () => [
    {
      id: origemEnum.ESCOLA,
      descricao: "Escola",
    },
    {
      id: origemEnum.GRE,
      descricao: "GRE",
    },
    {
      id: origemEnum.SEE,
      descricao: "SEE",
    },
  ],
};

export default origemEnum;
